<template>
  <div class="project-list-section">

    <div class="project-side-section">
      <ProjectSideNav></ProjectSideNav>
    </div>

    <div class="project-content-section">
      <!--
      <div class="pl-title">
        <img src="@/assets/img/BrainDump_icon1.png" style="width: 45px;"> My Outlines
      </div>
      -->

      <div class="list-section">

        <div class="list-title">
          <i class="fas fa-caret-right" v-show='!favActive' @click="favActive=!favActive"></i>
          <i class="fas fa-caret-down" v-show='favActive' @click="favActive=!favActive"></i>
          Favorite Projects
        </div>

        <div class="pl-options" v-show='favActive'>
          <router-link to='/project-details'>
            <div class="pl-option-border">
              <v-icon class='icon-plus'>fas fa-plus-circle</v-icon>
            </div>
          </router-link>
          <div class="pl-option-title">
            Create New
          </div>
        </div>
      </div>

      <div class="list-section" v-if='projects' :key='changeTeamState'>

        <div class="list-title">
          <i class="fas fa-caret-right" v-show='!teamActive' @click="teamActive=!teamActive"></i>
          <i class="fas fa-caret-down" v-show='teamActive' @click="teamActive=!teamActive"></i>
          Team Projects
        </div>

        <div v-show='teamActive' v-for='project in projects.personalProjects' class="pl-options">
          <router-link :to="project.id+'/dashboard'">
            <div class="pl-option-border-custom" style="color: #fff;">
              <img :src="project.img">
            </div>
          </router-link>
          <div class="pl-option-title">
            {{project.title}}
          </div>
          <div class="pl-option-subtitle">
            {{project.created_at.substring(0,10)}}
          </div>
        </div>

        <div v-if='projects' v-show='personalActive' v-for='project in projects.teamProjects' class="pl-options">
          <router-link :to="project.id+'/dashboard'">
            <div class="pl-option-border-custom" style="color: #fff;">
              <img :src="project.img">
            </div>
          </router-link>
          <div class="pl-option-title">
            {{project.title}}
          </div>
          <div class="pl-option-subtitle">
            {{project.created_at.substring(0,10)}}
          </div>
        </div>
      </div>

      <div class="list-section">

        <div class="list-title">
          <i class="fas fa-caret-right" v-show='!personalActive' @click="personalActive=!personalActive"></i>
          <i class="fas fa-caret-down" v-show='personalActive' @click="personalActive=!personalActive"></i>
          Personal Projects
        </div>

        <div v-if='personalProjects' v-show='personalActive' v-for='project in personalProjects' class="pl-options">
          <router-link :to="project.id+'/dashboard'">
            <div class="pl-option-border-custom" style="color: #fff;">
              <img :src="project.img">
            </div>
          </router-link>
          <div class="pl-option-title">
            {{project.title}}
          </div>
          <div class="pl-option-subtitle">
            {{project.created_at.substring(0,10)}}
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'

// components
import ProjectSideNav from '@/components/project-list/Side-nav'

export default {
  name: 'ProjectList',
  components: {
    ProjectSideNav
  },

  data () {
  	return {
  	 projects: null,
     imageUrl: process.env.VUE_APP_FILE_BASE,
     favActive: true,
     teamActive: true,
     personalActive: true,
     personalProjects: null
  	}
  },

  computed: {
    changeTeamState () {
      this.getProjects()
      this.getPersonalProjects()
      return this.$store.state.changeTeamState
    }
  },

  methods: {

    async getProjects () {
      const response = await api.projects.get()
      if (response.status < 300) {
        console.log('project', response.data)
        this.projects = response.data
      } else {
        console.log('Error loading projects', response)
      }
    },

    async getPersonalProjects () {
      const response = await api.users.getPersonalProjects()
      if (response.status < 300) {
        console.log('personal!', response.data)
        this.personalProjects = response.data
      } else {
        console.log('Error loading projects', response)
      }
    },

  },

  mounted () {
    this.getProjects()
    this.getPersonalProjects()
  }
}
</script>

<style lang="scss" scoped>

  .project-list-section {
    width: 100%;
    margin-top: 30px;

    .project-side-section {
      float: left;
      width: 270px;
      margin-right: 30px;
    }

    .project-content-section {
      float: left;
      width: calc(100% - 300px);
      margin-top: 12px;
      padding-left: 60px;

      .list-section {
        position: relative;
        overflow: auto;

        .list-title {
          width: 100%;
          margin-bottom: 15px;
          padding-bottom: 3px;
          font-size: 18px;
          font-weight: 600;
          border-bottom: 1px solid #dedede;

          i {
            cursor: pointer;
          }
        }
      }
    }

    .pl-title {
      margin-top: 0px;
      margin-bottom: 60px;
      font-size: 46px;
      font-weight: 700;
      text-align: center;
      color: #3a414f;

      .icon-brain {
        margin-top: -5px;
        font-size: 38px;
        color: #2063f1;
      }
    }

    .pl-subtitle {
      font-size: 22px;
      font-weight: 200;
      text-align: center;
      color: #aeb1b8;
    }

    .pl-options {
      float: left;
      width: 180px;
      height: 180px;
      margin-left: 18px;
      margin-right: 18px;
      margin-bottom: 90px;
      text-align: center;
      border-radius: 20px;
      background: #fff;
      transition: all 0.25s;

      a {
        text-decoration: none;
        outline: none;
      }

      &:hover {
        opacity: 0.7;
      }

      .pl-option-border {
        line-height: 176px;
        border: 3px dashed #dadada;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.7;
        }

        .icon-plus {
          font-size: 46px;
          opacity: 0.7;
          color: #dadada;
        }
      }

      .pl-option-border-custom {
        width: 176px;
        height: 176px;
        line-height: 176px;
        border: 2px solid #dadada;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.5s;
        overflow: hidden;

        &:hover {
          opacity: 0.7;
        }

        img {
          height: 176px;
        }

        .icon-plus {
          font-size: 46px;
          opacity: 0.7;
          color: #dadada;
        }
      }

      .pl-option-title {
        margin-top: 5px;
        font-size: 16px;
        font-weight: 600;
        color: #3A414F;
      }

      .pl-option-subtitle {
        margin-top: 0px;
        font-size: 16px;
        font-weight: 400;
        color: #aeb1b8;
        opacity: 0.7;
      }
    }
  }

</style>
